import React from 'react';
import PropTypes from 'prop-types';
import AliasField from "./AliasField";
import {CONFIG} from "../config";
import UrlField from "./UrlField";

const FarmAliasField = ({showId, showName, link, ...restProps}) => {
  const aliasField = <AliasField
    showId={showId}
    {...restProps}
  />;
  if (link) {
    const {record} = restProps;
    const r = {content: aliasField, id: record.id};
    return <UrlField
      record={r}
      source='content'
      hrefpattern={`${CONFIG.productUrl}/farms/{id}`}
      title={'Open farm in ' + CONFIG.productUrl}
    />
  }
  return aliasField;
};

FarmAliasField.propTypes = {
  record: PropTypes.object,

  showId: PropTypes.bool,
  link: PropTypes.bool,
};

FarmAliasField.defaultProps = {
  record: {},
  label: 'Farm',
  addLabel: true,

  showId: false,
  link: false,
};

export default FarmAliasField;
